import React, { useMemo, useState, useCallback, useRef } from 'react'
import ReactDOM from 'react-dom'
import { SketchPicker } from 'react-color'

// Usage:
//
// with hidden field
// add the `input` attr and reference the id of the text field.
//
// <input hidden="true" id="my_color_input" />
// <react-color-picker input="my_color_input"></react-color-picker>
//

const Component = ({ input }) => {
  const inputRef = useRef(document.getElementById(input))

  let defaultColor = '#fff'
  if (inputRef.current.value) {
    defaultColor = inputRef.current.value
  }
  const [color, setColor] = useState(defaultColor)

  const handleChangeComplete = useCallback((clr, event) => {
    setColor(clr.hex)
    inputRef.current.value = clr.hex
  }, [inputRef])

  const boxStyles = useMemo(() => ({
    width: '50px',
    height: '50px',
    backgroundColor: color
  }), [color])

  return (
    <div className='row'>
      <div className='col col-auto'><div className='shadow rounded border' style={boxStyles} /></div>
      <div className='col col-auto'><SketchPicker color={color} onChangeComplete={handleChangeComplete} /></div>
    </div>
  )
}

const Init = () => {
  // the main markdown tag for the editor
  const colorPickers = [...document.getElementsByTagName('react-color-picker')]

  if (colorPickers.length > 0) {
    colorPickers.forEach((el) => {
      el.style.display = 'block'

      // get the input id
      const inputId = el.getAttribute('input')
      if (inputId) {
        // check if the id exists
      }

      // get the input by the id
      const input = document.getElementById(inputId)
      if (input) {
        // do something with the input and update it on change
      }

      ReactDOM.render(<Component input={inputId} />, el)
    })
  }
}

document.addEventListener('turbo:load', Init)
